<style lang="scss">
@use '~@/styles/main';
@use '~@/styles/base/variables';

html {
  font-size: 62.5%; // 16px * 62.5 % = 10px
}

#hooks {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: grid;
  grid-template-columns: minmax(230px, 20%) 1fr;
  column-gap: 1rem;
  min-height: 100vh;
  color: #ffffff;
  min-width: 505px;

  .mobile-header {
    display: none;
    position: sticky;
    top: 0px;
    background-color: #404364;
    z-index: 3;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    text-overflow: ellipsis;
    color: white;
    font-weight: bold;
    padding: 1rem;
    box-shadow: 0 1px 3px #000000;

    &:hover,
    :focus {
      cursor: pointer;
    }

    &__hook-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 1rem;
    }

    &__arrow {
      width: 24px;
      height: 24px;
      min-width: 24px;
      min-height: 24px;
      fill: white;
      transition: 0.5s transform;
    }

    &_open {
      box-shadow: none;

      .mobile-header__arrow {
        transform: rotate(180deg);
      }
    }
  }

  @media screen and (max-width: variables.$standart) {
    .ivu-btn {
      padding: 1px 7px 2px;
    }
  }

  @media screen and (max-width: variables.$small) {
    display: block;
    background-color: #404364;

    .mobile-header {
      display: flex;
    }
  }
}
</style>

<template>
  <div id="hooks">
    <header
      v-if="currentHook && currentHook.Params"
      @click="showMobileHookList = !showMobileHookList"
      class="mobile-header"
      :class="{ 'mobile-header_open': showMobileHookList }"
    >
      <span class="mobile-header__hook-name">{{
        currentHook.Params.Name
      }}</span>
      <svg
        class="mobile-header__arrow"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M16 9v2l-4 4.24L8 11V9h8z"></path>
      </svg>
    </header>
    <HookList />
    <HookEdit />
  </div>
</template>

<script>
import HookList from '@/components/MainPage/Hooks/HookList.vue'
import HookEdit from '@/components/MainPage/Hooks/HookEdit.vue'
import hooks from '@/services/hooks'

export default {
  name: 'Hooks',
  components: {
    HookList,
    HookEdit
  },
  created () {
    hooks.getHooks()
  },
  computed: {
    currentHook () {
      return this.$store.getters.currentHook
    },
    showMobileHookList: {
      get () {
        return this.$store.state.hooks.showMobileHookList
      },
      set (value) {
        this.$store.state.hooks.showMobileHookList = value
      }
    }
  }
}
</script>
